export default __webpack_public_path__ + "static/media/event-busy.ddeb28ca.svg";